import React, { useEffect, useState } from "react";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { DIR_RTL } from "../../../constants/ThemeConstant";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { ContactInformationIcon } from "assets/svg/icon";
import "./style.css";
import { Button } from "antd";



function CheckoutProduct() {
    const { theme: { direction, locale }, cartData: { cartQuantity } } = useSelector(state => state);
    const [values, setValues] = useState({});
    const [checkValue, setCheckValue] = useState(false);
    const history = useHistory();
    const selected_mode = localStorage.getItem('selected-mode');

    const handleValue = (e) => {
        setValues(prev => ({ ...prev, [e.target.name]: e.target.value }));
    }

    useEffect(()=>{
        window.scrollTo({top:0, behavior: 'auto'});
        if (localStorage.getItem('contactInformation')!==null){
            setValues(JSON.parse(localStorage.getItem('contactInformation')));
        }
    }, [])

    const onFinish = () => {
        setCheckValue(true);
        if (values.name && values.phone) {
            localStorage.setItem('contactInformation', JSON.stringify(values));
            history.push(selected_mode === 'pickup' ? 'checkOutThree' : 'checkOutTwo');
        }
    }

    return (
        <div className="checkOut-page-style">
            <div className="checkOutNav">
                <div onClick={() => window.history.back()}>
                    <ArrowLeftOutlined rotate={direction === DIR_RTL ? 180 : 0} style={{ fontSize: '24px', cursor: 'pointer', color: 'black' }} />
                </div>
                <div className='text-center w-100' style={{ fontSize: "17px", color: '#000', fontWeight: '600' }}>Checkout</div>
            </div>
            <div className="checkout-status">
                <span style={{backgroundColor: "var(--primaryColor)"}}/>
                {selected_mode === 'pickup' ? '' : <span style={{backgroundColor: "grey"}}/>}
                <span style={{backgroundColor: "grey"}}/>
                <span style={{backgroundColor: "grey"}}/>
            </div>
            <div className="checkOut-content">
                <div className={"text-center"}>
                    {ContactInformationIcon('mt-3', 'var(--primaryColor)')}
                    <h2 className={'mt-2'}> Contact information </h2>
                    <p className={'h4 text-muted'}> We’ll use it to get back to you for order updates </p>
                </div>
                <div className={'checkOut-form mt-5'}>
                    <div className={'checkOut-form-item'}>
                        <input type="text" name="name" onChange={handleValue} value={values?.name} />
                        <label className='labelName'>
                            <span className={`${values?.name || checkValue ? "select-content-name" : ""} content-name`}>Name</span>
                        </label>
                        <span className={`${checkValue ? (values?.name ? "d-none" : "") : "d-none"} checkOut-form-error`}> Please enter your name! </span>
                    </div>
                    <div className={'checkOut-form-item'}>
                        <input type="number" name="phone" onChange={handleValue} value={values?.phone}/>
                        <label className='labelName'>
                            <span className={`${values?.phone || checkValue  ? "select-content-name" : ""} content-name`}>Phone Number</span>
                        </label>
                        <span className={`${checkValue ? (values?.email ? "d-none" : "") : "d-none"} checkOut-form-error`}> Please enter your number! </span>
                    </div>
                    <div className={'checkOut-form-item'}>
                        <input type="email" name="email" onChange={handleValue} value={values?.email}/>
                        <label className='labelName'>
                            <span className={`${values?.email ? "select-content-name" : ""} content-name`}>Email (Optional) </span>
                        </label>
                    </div>
                </div>
            </div>
            <div className='orderCheckoutContainer branch-btn'>
                <Button onClick={onFinish} className={`w-100 orderCheckout btn-project primaryColor`}>
                    Next
                </Button>
            </div>
            {/* <div className="checkOut-finish-btn">
                <button className="primaryColor" onClick={onFinish}> <span> Next </span> </button>
            </div> */}
        </div>
    )
}


export default CheckoutProduct;